export default "__VITE_ASSET__BqXzlOHY__"